import styles from './Pagination.module.scss';

interface Props {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<Props> = ({ page, totalPages, onPageChange }) => {
  if (totalPages < 1) return null;

  return (
    <div className={styles.pagination}>
      {page > 3 && <a onClick={() => onPageChange(1)}>{1}</a>}
      {page > 4 && <span>...</span>}
      {page > 2 && <a onClick={() => onPageChange(page - 2)}>{page - 2}</a>}
      {page > 1 && <a onClick={() => onPageChange(page - 1)}>{page - 1}</a>}
      <em>{page}</em>
      {page <= totalPages - 1 && (
        <a onClick={() => onPageChange(page + 1)}>{page + 1}</a>
      )}
      {page <= totalPages - 2 && (
        <a onClick={() => onPageChange(page + 2)}>{page + 2}</a>
      )}
      {page <= totalPages - 4 && <span>...</span>}
      {page <= totalPages - 3 && (
        <a onClick={() => onPageChange(totalPages)}>{totalPages}</a>
      )}
    </div>
  );
};

export default Pagination;
